import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Sidebar from '../components/sidebar/sidebar';

export default function Layout({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#fff7f0',
        flexDirection: { xs: 'column', md: 'row' }
      }}
    >
      {/* Sidebar */}
      <Box
        component="aside"
        dir="rtl"
        sx={{
          width: { xs: '100%', md: '19vw' },
          flexShrink: 0,
          backgroundColor: '#f8f9fa'
        }}
      >
        <Sidebar />
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        dir="rtl"
        sx={{
  flexGrow: 1,
  padding: { xs: '16px', sm: '20px' },
  backgroundColor: '#fff7f0',
  // Make sure there's no conflicting overflow property
}}
      >
        {children}
      </Box>
    </Box>
  );
}